<p-panel header="Clinical Information">
  <div class="f-io">
    <mnc-formio
      lazyComponent
      [form]="formConfig"
      [submission]="submission"
      (change)="onChange($event)"
    ></mnc-formio>
  </div>

  <div class="flex justify-between mt-4">
    <div>
      <button
        pButton
        severity="danger"
        aria-label="Cancel Create Authorization"
        label="Cancel"
        icon="pi pi-times"
        type="button"
        data-test-id="cancel-request-button"
        (click)="onCancel()"
      ></button>
    </div>
    <div>
      <button
        pButton
        aria-label="Back Step to Ordering Provider"
        label="Back"
        icon="pi pi-arrow-left"
        class="p-button-secondary mr-2"
        type="button"
        data-test-id="back-step-button"
        (click)="onClickBack()"
      ></button>
      <button
        pButton
        aria-label="Next Step to Documents"
        label="Next"
        icon="pi pi-arrow-right"
        iconPos="right"
        type="button"
        data-test-id="next-step-button"
        [disabled]="!isNextStepEnabled"
        (click)="onSubmit()"
      ></button>
    </div>
  </div>


  <p-confirmDialog
    #bypass
    header="Do you have a Carelon request form with clinical information completed?"
    styleClass="confirmation-message-no-body"
    appendTo="body"
    [closable]="false"
    [style]="{ width: '420px' }"
    rejectButtonStyleClass="p-button-info"
    rejectLabel="No"
    acceptLabel="Yes"
  >
  </p-confirmDialog>
</p-panel>
